import { useState } from 'react';

import type { ProtocolRuleResponse } from 'generated/index';

/**
 * Whether the rule panel is open, and for which rule. The rule is kept while the panel slides shut, so
 * its title does not flip from "edit" to "add" during the animation.
 */
export const useProtocolRuleDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [rule, setRule] = useState<ProtocolRuleResponse>();

  const open = (ruleToEdit?: ProtocolRuleResponse) => {
    setRule(ruleToEdit);
    setIsOpen(true);
  };

  return {
    isOpen,
    rule,
    openCreate: () => open(),
    openEdit: (ruleToEdit: ProtocolRuleResponse) => open(ruleToEdit),
    close: () => setIsOpen(false)
  };
};
